<template>
  <div>
    <div id="new-note-button-mobile-wrapper">
      <button
        id="new-note-button-mobile"
        class="button-large"
        @click="createNewNote()"
      >
        new note
      </button>
    </div>

    <div id="notes-list-container">
      <div
        v-for="note in notes"
        :key="note.timestamp"
        class="single-note-wrapper"
      >
        <div
          class="single-note"
          v-bind:class="{ selected: note.id === activeNote.id }"
        >
          <div class="note-wrapper" @click="openNote(note)">
            {{ note.title }}
          </div>
          <div class="button-wrapper">
            <button
              class="delete-button-small button-small"
              @click="openConfirmationModal(note)"
            >
              <img
                src="../assets/iconmonstr-trash-can-28-24.png"
                alt="Delete the note"
                width="20"
                height="20"
                style="margin: 0px 5px"
              />
            </button>
            <!--
            <button 
              class="save-button-small button-small"
              @click="saveNote()"
            >
              S
            </button>
            -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import store from "../store";
import { defaultNote } from "../store";

export default {
  name: "NotesList",
  components: {},

  data() {
    return {
      activeNote: {},
    };
  },

  setup() {
    let notes = computed(function () {
      let notes = store.state.notes;

      if (store.state.filterText) {
        notes = notes.filter((note) => {
          let tags = String(note.tags).toLowerCase();
          let title = note.title.toLowerCase();
          let content = note.content.toLowerCase();
          return (
            tags.includes(store.state.filterText) ||
            title.includes(store.state.filterText) ||
            content.includes(store.state.filterText)
          );
        });
      }

      return notes.sort((a, b) => {
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        if (a.timestamp > b.timestamp) {
          return -1;
        }

        return 0;
      });
    });

    return {
      notes,
    };
  },

  methods: {
    createNewNote() {
      store.commit("setActiveNote", { ...defaultNote });
      this.openNote({ ...defaultNote });
    },

    openNote(note) {
      this.activeNote = note;
      store.commit("setActiveNote", note);
      this.hideNotesList();
    },

    hideNotesList() {
      if (window.innerWidth <= 430) {
        document.getElementById("notes-list").style.display = "none";
        document.getElementById("note").style.display = "block";
        document.getElementById("note").style.width = "100%";
        document.getElementById("show-notes-list-button").style.display =
          "inline";
        document.getElementById("new-note-button").style.display = "inline";
      }
    },

    openConfirmationModal(note) {
      console.log("emitting: ", note);
      this.$emit("open-confirmation-modal", note);
    },
  },
};
</script>

<style>
#notes-list-container {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;

  border-right: 1px solid hsl(174, 72%, 36%);
  padding-bottom: 50px;
}

.single-note-wrapper:last-child .single-note {
  border-bottom: 0px;
}

.single-note {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  padding: 5px 5px 5px 10px;
  border-bottom: 1px solid hsl(174, 72%, 36%);
}

.note-wrapper {
  overflow: hidden;
  text-overflow: ellipsis;

  box-sizing: border-box;
  width: 100%;
  text-align: left;
  margin: auto;
}

.single-note:hover {
  cursor: pointer;
  background-color: hsl(174, 72%, 46%);
}

.single-note:hover .delete-button-small {
  background-color: hsl(174, 72%, 76%);
}

:is(.single-note:hover, .selected) .delete-button-small:hover {
  background-color: hsl(174, 72%, 66%);
}

:is(.single-note:hover, .selected) .delete-button-small:active {
  background-color: hsl(174, 72%, 56%);
}

:is(.single-note:hover, .selected) .delete-button-small {
  background-color: hsl(174, 72%, 76%);
}

.selected {
  background-color: hsl(174, 72%, 46%);
}

.selected:hover {
  background-color: hsl(174, 72%, 56%);
}

.selected:hover .delete-button-small:hover {
  background-color: hsl(174, 72%, 46%);
}

.selected:hover .delete-button-small:active {
  background-color: hsl(174, 72%, 36%);
}

.button-wrapper {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  margin-right: 0.5rem;
  overflow: unset;
}

.button-wrapper button {
  border: 0px;
  border-radius: 10px;
  z-index: 10;
  padding: 0.1rem 0;
}

.delete-button-small {
  background-color: hsl(174, 72%, 46%);
}

.delete-button-small:hover {
  background-color: hsl(174, 72%, 56%);
}

.delete-button-small:active {
  background-color: hsl(174, 72%, 76%);
}

.save-button-small {
  background-color: hsl(174, 72%, 76%);
}

.save-button-small:hover {
  background-color: hsl(174, 72%, 56%);
}

.save-button-small:active {
  background-color: hsl(174, 72%, 46%);
}

#new-note-button-mobile {
  display: none;
}

#new-note-button-mobile {
  background-color: hsl(174, 72%, 76%);
}

#new-note-button-mobile:hover {
  background-color: hsl(174, 72%, 56%);
}

#new-note-button-mobile:active {
  background-color: hsl(174, 72%, 46%);
}

@media (max-width: 430px) {
  #notes-list-container {
    border-right: 0px;
  }
}
</style>